module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-results-videoPoster.jpg?h=d6065cc79bcea7ca88c994fb18e9773c";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-results-videoPoster.jpg
// module id = 2117
// module chunks = 12 15